// Presentation only: amounts and rounding always come from the server preview.
function formula(part, saved) {
    if (saved && saved.formula_error) return null;
    const rule = part.calculation_rule;
    if (!rule) return saved && saved.formula || null;
    if (!Number.isFinite(Number(part.coefficient_bp)) || Number(part.coefficient_bp) < 1) return null;
    const ktu = rule.ktu == null ? 4 : Number(rule.ktu);
    return {rate_minor: Number(part.rate_minor), coefficient: Number(part.coefficient_bp) / 10000,
        ktu, ktu_factor: Math.round(ktu / 4 * 10000) / 10000,
        denominator: part.basis === 'monthly' ? (rule.denominator_type === 'none' ? 1 : Number(rule.fixed_denominator)) : 1,
        rounding: rule.rounding_mode || 'half_up'};
}

module.exports = {formula};
